import { useOfflineSync } from "@/hooks/useOfflineSync";
import { Wifi, WifiOff, CloudUpload, Loader2 } from "lucide-react";

export default function OfflineBadge() {
  const { online, pendingCount, syncing, syncNow } = useOfflineSync();

  // Rien à afficher si en ligne et aucune file : pas de bruit visuel
  if (online && pendingCount === 0) return null;

  const label = !online
    ? pendingCount > 0 ? `Hors-ligne — ${pendingCount} en attente` : "Hors-ligne"
    : syncing ? `Synchronisation…` : `${pendingCount} à synchroniser`;

  const color = !online
    ? "bg-amber-50 text-amber-700 border-amber-300"
    : "bg-blue-50 text-blue-700 border-blue-300";

  return (
    <button
      onClick={() => online && !syncing && syncNow()}
      data-testid="offline-badge"
      disabled={!online || syncing}
      title={!online ? "Vos saisies sont sauvegardées localement" : "Cliquer pour synchroniser maintenant"}
      className={`${color} text-xs border px-2.5 py-1 rounded-full flex items-center gap-1.5 font-medium transition-opacity ${online ? "hover:opacity-80" : ""}`}
    >
      {syncing ? <Loader2 className="h-3 w-3 animate-spin" /> : !online ? <WifiOff className="h-3 w-3" /> : <CloudUpload className="h-3 w-3" />}
      <span>{label}</span>
    </button>
  );
}
